import { MARKET_ANALYSIS_RECEIVED } from "../shared/constants";

const initialMarketAnalysisState = {
	data: undefined
};

export const marketAnalysis = (state = initialMarketAnalysisState, action) => {
	switch (action.type) {
		case MARKET_ANALYSIS_RECEIVED:
			return {
				...state,
				data: action.data
			};

		default:
			return state;
	}
};
